import React from 'react';
import { Home, Building, Store, Users, Warehouse, Briefcase } from 'lucide-react';

const WhoWeWorkWithSection = () => {
  const clients = [
    { icon: Home, title: 'Homeowners & Residential Properties' },
    { icon: Users, title: 'Landlords & Letting Agents' },
    { icon: Building, title: 'Commercial Units & Offices' },
    { icon: Store, title: 'Supermarkets & Retail Chains' },
    { icon: Warehouse, title: 'Independent Shops & Off-Licences' },
    { icon: Briefcase, title: 'Facilities Managers & Developers' },
  ];

  return (
    <section className="py-24 bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Who We Work With
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            No matter the size or complexity, we deliver the same level of precision, reliability, and care.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {clients.map((client, index) => (
            <div
              key={index}
              className="group p-8 bg-gray-900/50 border border-gray-800 rounded-xl hover:border-amber-600/50 hover:bg-gray-800/50 transition-all duration-300 hover:shadow-xl hover:shadow-amber-500/10"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="p-4 bg-amber-600/10 rounded-full group-hover:bg-amber-600/20 transition-colors duration-300">
                  <client.icon className="w-8 h-8 text-amber-500" />
                </div>
                <h3 className="text-lg font-semibold text-white">
                  {client.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeWorkWithSection;
